import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore } from '@store';

@Component({
  selector: 'app-flat-subscription-summary',
  templateUrl: './flat-subscription-summary.component.html',
  styleUrls: ['./flat-subscription-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatSubscriptionSummaryComponent {
  bookingPlans = SubscriptionPlan;

  constructor(public bookingStore: BookingStore) {}
}
